import { message } from "antd";
import axios from "axios";
import polizaPdf from "../Pdf/polizaPdf";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import store from "../store/store";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const NotificacionPolizas = (polizasId) => {
  const storeRedux = store.getState()
  const empresaId = storeRedux.empresa.id;
  const headersToken = storeRedux.user.headersToken;
  const tipoUsuario = storeRedux.user.tipo
  const permisoNP = storeRedux.user.permisos.find(
    (valueTodos) =>
      valueTodos.permisoId.toString() === "6489fc4b29c170cb2c526b9a"
  )?.activado
  const permisoNotificacionPolizas = tipoUsuario === 0 || permisoNP

  //Abrir la hoja con las polizas del movimiento en cuanto termina, sin esperar a que el usuario
  //entre al documento a buscarlas. Es independiente de la notificacion de arriba: cada una tiene
  //su propio permiso y pueden estar prendidas por separado.
  const permisoVerPolizaMovimiento = tipoUsuario === 0 || storeRedux.user.permisos.find(
    (valueTodos) =>
      valueTodos.permisoId.toString() === "6a9b586052b97b73c85f2a95"
  )?.activado
  if (
    polizasId?.length &&
    storeRedux.empresa.verPolizaAlRealizarMovimiento &&
    permisoVerPolizaMovimiento &&
    window.abrirPolizasMovimiento
  ) {
    window.abrirPolizasMovimiento(polizasId)
  }

  //Un arreglo vacio es truthy: sin este length se anunciaba "Se emitieron 0 polizas" cuando
  //la operacion no genero ninguna (venta No Contable, factura sin poliza, CXC sin contabilidad)
  if (polizasId?.length && permisoNotificacionPolizas) {
    // Registrar movimiento en lugar de mostrar popup
    if (window.registrarMovimiento) {
      const mensajePolizas = polizasId.length === 1
        ? "Se emitió " + polizasId.length + " póliza"
        : "Se emitieron " + polizasId.length + " pólizas";

      window.registrarMovimiento({
        titulo: mensajePolizas,
        mensaje: "Haga click para descargar",
        icono: 2, // DownloadOutlined
        onClick: () => {
          const hideLoading = message.loading('Descargando pólizas...', 0);
          axios
            .post(
              "polizas/datosPolizas",
              { polizasId, empresaId },
              { headers: headersToken }
            )
            .then((resPolizas) => {
              hideLoading();
              if (resPolizas.data.success === 2) {
                resPolizas.data.polizas.forEach((poliza) => {
                  const pdfPoliza = polizaPdf(poliza);
                  pdfMake
                    .createPdf(pdfPoliza)
                    .download(
                      poliza?.poliza?.tipodepoliza?.descripcion
                        ? "Póliza_" +
                            poliza.poliza.tipodepoliza.descripcion +
                            " - " +
                            poliza.poliza.numeroTipoPoliza
                        : "Póliza"
                    );
                });
                message.success('Pólizas descargadas correctamente');
              } else {
                message.error(
                  "Ha sucedido un error y no se cargaron bien las pólizas"
                );
              }
            })
            .catch(() => {
              hideLoading();
              message.error("Error al descargar las pólizas");
            });
        },
      });
    }
  } else {
    return null;
  }
};

export default NotificacionPolizas;
